module.exports = __webpack_public_path__ + "img/nlc_logo.cb0772fb.png";